<script setup>
  import ComponentAlert from "@components/Alerts/Alert.vue";
  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "ComponentPrivacyGuard",
  });

  defineProps({
    type: {
      type: String,
      default: "default", // 'strict'
    },
    validation: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <div class="print:hidden">
    <ComponentAlert
      v-if="type === 'strict'"
      :type="validation ? 'error' : 'info'"
      :test-id="getTestId('privacy-guard')"
    >
      <ComponentIcon class="inline-block">lock</ComponentIcon>
      {{ validation ?? "Bitte keine personenbezogenen Daten eingeben." }}
    </ComponentAlert>

    <div
      v-else
      :class="{'text-gray-500': !validation, 'text-mcred': validation}"
      :data-test="getTestId('privacy-guard-' + (validation ? 'warining' : 'info'))"
    >
      <ComponentIcon class="inline-block">lock</ComponentIcon>
      {{ validation ?? "Bitte keine personenbezogenen Daten eingeben." }}
    </div>
  </div>
</template>
